import common from './common';
import fieldValidation from './fieldValidation';
import invoiceManagement from './invoiceManagement';

const th = { common, invoiceManagement, fieldValidation };
export default th;
